var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUpWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.318 5.683L5.735.315C5.945.104 6.222 0 6.5 0s.555.105.766.315l5.417 5.367c.423.42.423 1.1 0 1.519a1.09 1.09 0 01-1.532 0L7.583 3.664v10.293c0 .593-.485 1.043-1.052 1.043-.568 0-1.114-.45-1.114-1.043V3.664L1.848 7.2a1.09 1.09 0 01-1.531 0 1.064 1.064 0 01.001-1.517z",
    fill: "#FFF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxMyAxNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0uMzE4IDUuNjgzIDUuNzM1LjMxNUM1Ljk0NS4xMDQgNi4yMjIgMCA2LjUgMHMuNTU1LjEwNS43NjYuMzE1bDUuNDE3IDUuMzY3Yy40MjMuNDIuNDIzIDEuMSAwIDEuNTE5YTEuMDkgMS4wOSAwIDAgMS0xLjUzMiAwTDcuNTgzIDMuNjY0djEwLjI5M2MwIC41OTMtLjQ4NSAxLjA0My0xLjA1MiAxLjA0My0uNTY4IDAtMS4xMTQtLjQ1LTEuMTE0LTEuMDQzVjMuNjY0TDEuODQ4IDcuMmExLjA5IDEuMDkgMCAwIDEtMS41MzEgMCAxLjA2NCAxLjA2NCAwIDAgMSAuMDAxLTEuNTE3eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=";
export { SvgArrowUpWhite as ReactComponent };